import React from 'react';
import * as s from './styled-modal-close';

const ModalClose = ({
  id = 'close',
  labelClose,
  labelButtonClose,
  colorClose,
  onClose,
  onCloseConfirmation, }) => {

  return (
    <s.Modal id={id} role="dialog" aria-modal="true">
      <s.ContainerClose>
        {onCloseConfirmation && (
          <s.Elemento position="absolute" align="end" width="33%">
            <s.ButtonClose
              type="button"
              aria-label="Fechar"
              onClick={() => onCloseConfirmation(false)}
            >
              X
            </s.ButtonClose>
          </s.Elemento>
        )}
        <s.Text>{labelClose || 'Deseja fechar?'}</s.Text>
        <s.Line>
          <s.Button
            type="button"
            color={colorClose || '#ff3838'}
            onClick={onClose}
          >
            {labelButtonClose || 'CONFIRMAR'}
          </s.Button>
        </s.Line>
      </s.ContainerClose>
    </s.Modal>
    )
  };

export default ModalClose;
